export default function LoadingIndicator() {
  return (
    // eslint-disable-next-line tailwindcss/no-custom-classname
    <div className="loader">
      <img src="/spinner.gif" id="spinner" alt="spinner" />
    </div>
  );
}
